import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
interface RestorePayload {
  signature: string;
  anchorHospitalId: number;
  anchorTopOffsetPx?: number;
}
const STORAGE_KEY = "search-result:scroll-restore";
const DEFAULT_ANCHOR_TOP_OFFSET_PX = 0;
const MAX_RESTORE_FETCH_PAGES = 50;
export const useSearchResultAnchorScrollRestore = t0 => {
  const $ = _c(11);
  const {
    signature,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage
  } = t0;
  const restoreStartedRef = useRef(false);
  const restoreFetchCountRef = useRef(0);
  let t1;
  let t2;
  if ($[0] !== signature) {
    t1 = () => {
      if (restoreStartedRef.current) {
        return;
      }
      if (typeof window === "undefined") {
        return;
      }
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return;
      }
      try {
        const parsed = JSON.parse(raw) as RestorePayload;
        if (parsed.signature !== signature) {
          return;
        }
        restoreStartedRef.current = true;
      } catch {
        window.sessionStorage.removeItem(STORAGE_KEY);
      }
    };
    t2 = [signature];
    $[0] = signature;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== fetchNextPage || $[4] !== hasNextPage || $[5] !== isFetchingNextPage || $[6] !== signature) {
    t3 = () => {
      if (!restoreStartedRef.current) {
        return;
      }
      if (typeof window === "undefined") {
        return;
      }
      const raw_0 = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw_0) {
        return;
      }
      let parsed_0;
      try {
        parsed_0 = JSON.parse(raw_0);
      } catch {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      if (!parsed_0 || parsed_0.signature !== signature) {
        return;
      }
      const selector = `[data-search-result-anchor="${parsed_0.anchorHospitalId}"]`;
      const el = document.querySelector(selector);
      if (el) {
        const desiredOffsetPx = typeof parsed_0.anchorTopOffsetPx === "number" ? parsed_0.anchorTopOffsetPx : DEFAULT_ANCHOR_TOP_OFFSET_PX;
        requestAnimationFrame(() => {
          const desiredY = window.scrollY + el.getBoundingClientRect().top - desiredOffsetPx;
          window.scrollTo({
            top: Math.max(0, desiredY),
            behavior: "auto"
          });
          window.sessionStorage.removeItem(STORAGE_KEY);
        });
        return;
      }
      if (!hasNextPage) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      if (isFetchingNextPage) {
        return;
      }
      if (restoreFetchCountRef.current >= MAX_RESTORE_FETCH_PAGES) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      restoreFetchCountRef.current = restoreFetchCountRef.current + 1;
      fetchNextPage();
    };
    t4 = [fetchNextPage, hasNextPage, isFetchingNextPage, signature];
    $[3] = fetchNextPage;
    $[4] = hasNextPage;
    $[5] = isFetchingNextPage;
    $[6] = signature;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== signature) {
    const saveAnchor = (hospitalOriginId, anchorEl) => {
      if (typeof window === "undefined") {
        return;
      }
      if (!hospitalOriginId) {
        return;
      }
      const anchorTopOffsetPx = anchorEl?.getBoundingClientRect().top ?? DEFAULT_ANCHOR_TOP_OFFSET_PX;
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        signature,
        anchorHospitalId: hospitalOriginId,
        anchorTopOffsetPx
      } satisfies RestorePayload));
    };
    t5 = {
      saveAnchor
    };
    $[9] = signature;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};